import _ from 'lodash'
import template from './sql-console-form.hbs'
import * as reportFormHelper from '../common/report-form-helper'
import BaseReportEditForm from '../common/base-report-form'
import TextArea from 'scoreboard/components/textarea'

var SqlConsoleForm = BaseReportEditForm.extend({

	className: 'table-hack-row display-pane-body',

	events: {
		'change [name=query]': 'onChangeQuery'
	},

	initialize: function(options) {
		this.options = options
		reportFormHelper.listenToChanges(this)
		this.on('change', function() {
			this.model.set('query', _.trim(this.$('.query').val()))
		}.bind(this))
		this.model.set('run', false, {silent: true})
	},

	render: function() {
		this.$el.html(template(this.model.attributes))
		this._initLabelField()
		this.queryTexarea = new TextArea({ el: this.$('textarea.query') }).render()
		// #50417 only hide the title when editing report from dashboards section
		this.$('.title-row').toggleClass('is-not-displayed', !!this.options.embedded)
		return this
	},

	onChangeQuery: function() {
		this.model.set('query', this.$('[name=query]').val())
	}

})

export default SqlConsoleForm

SqlConsoleForm.__filename__ = 'reports/sql-console/sql-console-form.js'
